// Single source of truth for a dossier / client `type` value and its French
// label + badge colour. Previously duplicated inline in DossierDetailScreen,
// OrdreModal and ClientVehicleReviewModal — notably the "professionnel" → "Entreprise"
// relabel. Keep the stored value (`professionnel`), only the label reads "Entreprise".

export const CLIENT_TYPE_BADGE: Record<string, { bg: string; text: string; label: string }> = {
  professionnel: { bg: "#10b981", text: "#FFFFFF", label: "Entreprise" },
  particulier: { bg: "#6366f1", text: "#FFFFFF", label: "Particulier" },
  loueur: { bg: "#f59e0b", text: "#FFFFFF", label: "Loueur" },
  garantie: { bg: "#ef4444", text: "#FFFFFF", label: "Garantie" },
  occasion: { bg: "#8b5cf6", text: "#FFFFFF", label: "Véhicule occasion" },
  interne: { bg: "#64748b", text: "#FFFFFF", label: "Véhicule interne" },
};

/** French label for a client/dossier type value (empty string if unknown/undefined). */
export const clientTypeLabel = (t?: string | null): string =>
  (t ? CLIENT_TYPE_BADGE[t]?.label : "") || "";

/** Full dossier-type dropdown (OrdreModal "Type de dossier", dossier edit). */
export const DOSSIER_TYPE_OPTIONS = [
  { value: "", label: "Non défini" },
  { value: "particulier", label: "Particulier" },
  { value: "professionnel", label: "Entreprise" },
  { value: "loueur", label: "Loueur" },
  { value: "garantie", label: "Garantie" },
  { value: "occasion", label: "Véhicule occasion" },
  { value: "interne", label: "Véhicule interne" },
];

/** Party `type_client` dropdown for a vehicle owner/company/user block —
 * a party is a particulier, an entreprise, or a loueur. */
export const PARTY_TYPE_OPTIONS = [
  { value: "", label: "—" },
  { value: "particulier", label: "Particulier" },
  { value: "professionnel", label: "Entreprise" },
  { value: "loueur", label: "Loueur" },
];
